import type {
  MedicationActivity,
  DeepPartial,
} from "@tandemdiabetes/sugarmate-api-react-client"
import dayjs from "dayjs"
import {
  useCallback,
  useEffect,
  useRef,
} from "react"
import type { DeepReadonlyObject } from "rxdb"
import { accountMedicationToActivityMedication } from "./accountMedicationToActivityMedication"
import { useNewestAccountMedication } from "src/hooks"
import type { AccountMedication } from "src/types"

export function useOnAccountMedicationCreated(
  activity: DeepPartial<MedicationActivity> | undefined,
  updateActivity: (a: DeepPartial<MedicationActivity>) => void,
) {
  const lastUpdatedRef = useRef<string>(dayjs().toISOString())
  const newestAccountMedication = useNewestAccountMedication()

  // this function updates the activity with the provided account medication
  const updateActivityWithAccountMedication = useCallback(
    (accountMedication: DeepReadonlyObject<AccountMedication>) => {
      updateActivity({
        num_units: activity?.medication
          ? undefined
          : activity?.num_units,
        medication: accountMedicationToActivityMedication(accountMedication),
      })
    },
    [
      activity,
      updateActivity,
    ],
  )

  useEffect(
    () => {
      if (
        newestAccountMedication &&
        dayjs(newestAccountMedication.created_at).isAfter(lastUpdatedRef.current)
      ) {
        updateActivityWithAccountMedication(newestAccountMedication)
        lastUpdatedRef.current = newestAccountMedication.created_at
      }
    },
    [
      lastUpdatedRef,
      newestAccountMedication,
      updateActivityWithAccountMedication,
    ],
  )
}
